import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { LocaleService } from './_utility';
import { Constants } from './_utility/Constants';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { SpinnerService } from './_components/spinner/spinner.service';
import { SpinnerComponent } from './_components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, Toast, SpinnerComponent],
})
export class AppComponent implements OnInit {
  title = 'my-italian-admin-panel';
  protected readonly Constants = Constants;

  constructor(
    private route: Router,
    private locale: LocaleService,
    private spinner: SpinnerService,
  ) {
    this.locale.init();
  }

  ngOnInit() {}

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: Event): void {
    if (event instanceof NavigationStart) {
      this.spinner.show();
    }
    if (event instanceof NavigationEnd) {
      this.spinner.hide();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.spinner.hide();
    }
    if (event instanceof NavigationError) {
      this.spinner.hide();
    }
  }

  private getRouteData(route: any): any {
    // Extract route data to generate breadcrumbs
    // This is a placeholder implementation
    let data = {};
    while (route.firstChild) {
      route = route.firstChild;
      data = { ...data, ...route.snapshot.data };
    }
    return data;
  }
}
